import { ApiError } from "../api/client";

// Reads the zod.flatten() shape from a validation_failed ApiError.
// Server format (Plan 02): { code: "validation_failed", details: { fieldErrors: { email: ["..."] } } }
export function pickFieldError(
  error: ApiError | null | undefined,
  field: string,
): string | undefined {
  if (!error || error.code !== "validation_failed") return undefined;
  const details = error.details as
    | { fieldErrors?: Record<string, string[]> }
    | null
    | undefined;
  const msgs = details?.fieldErrors?.[field];
  return msgs && msgs.length > 0 ? msgs[0] : undefined;
}
